import { render, staticRenderFns } from "./detail_he.vue?vue&type=template&id=552ab356&scoped=true"
import script from "./detail_he.vue?vue&type=script&lang=js"
export * from "./detail_he.vue?vue&type=script&lang=js"
import style0 from "./detail_he.vue?vue&type=style&index=0&id=552ab356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ab356",
  null
  
)

/* custom blocks */
import block0 from "./detail_he.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports